import App from '../App'
// import Login from '../pages/login/index.vue'
/**
 * auth true登录才能访问，false不需要登录，默认true
 */

export default [
  {
    path: '/',
    component: App,
    children: [
      {
        path: '/initialAddress', // 注册
        meta: { auth: false },
        component: resolve => require(['../pages/initial-address'], resolve)
      },
      {
        path: '/fillBedNo', // 注册
        meta: { auth: false },
        component: resolve => require(['../pages/initial-address'], resolve)
      },
      {
        path: '/register', // 注册
        meta: { auth: false },
        component: resolve => require(['../pages/login/register'], resolve)
      },
      {
        path: '/login', // 登录
        meta: { auth: false },
        component: resolve => require(['../pages/login/login'], resolve)
      },
      {
        path: '/menu',
        component: resolve => require(['../pages/home/makeOrder/menu'], resolve)
      },
      {
        path: '/confirmPatientInfo',
        component: resolve => require(['../pages/home/confirmPatientInfo'], resolve)
      },
      {
        path: '/confirmOrder',
        component: resolve => require(['../pages/home/makeOrder/confirmOrder'], resolve)
      },
      {
        path: '/pay',
        component: resolve => require(['../pages/home/makeOrder/pay'], resolve)
      },
      {
        path: '/wxPayResult',
        component: resolve => require(['../pages/home/makeOrder/wxPayResult'], resolve)
      },
      {
        path: '/initialAddress',
        meta: { auth: false },
        component: resolve => require(['../pages/initial-address'], resolve)
      },
      {
        path: '/description',
        meta: { auth: false },
        component: resolve => require(['../pages/description'], resolve)
      },
      {
        path: 'orderInfo',
        component: resolve => require(['../pages/home/orderInfo'], resolve)
      },
      {
        path: '/home', // 个人主页
        component: resolve => require(['../pages/home/home'], resolve),
        children: [
          {
            path: 'fromWE',
            meta: { auth: false },
            component: resolve => require(['../pages/home/periods'], resolve)
          },
          {
            path: 'periods',
            component: resolve => require(['../pages/home/periods'], resolve)
          },
          {
            path: 'records',
            component: resolve => require(['../pages/home/records'], resolve)
          },
          {
            path: 'my',
            component: resolve => require(['../pages/home/my'], resolve)
          },
          {
            path: 'personInfo',
            component: resolve => require(['../pages/home/personInfo'], resolve)
          },
          {
            path: 'personSetting',
            component: resolve => require(['../pages/home/personSetting'], resolve)
          },
          {
            path: 'changePassword',
            component: resolve => require(['../pages/home/changePassword'], resolve)
          },
          {
            path: 'transBed',
            component: resolve => require(['../pages/home/transBed'], resolve)
          }
        ]
      },
      {
        path: '/', // 首页
        meta: { auth: false },
        component: resolve => require(['../pages/login/login'], resolve)
      },
      {
        path: '*', //  其他页面，
        meta: { auth: false },
        component: resolve => require(['../pages/pageNotFound'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/config/routes.js